import { useState } from "react";
import { Button, Field, Input, Modal } from "../../shared/ui/index.js";
import { ModePicker } from "../leads/ConvertLeadDialog.js";
import { useCreateClient } from "./clients.api.js";

export function CreateClientDialog({ onClose }: { onClose: () => void }) {
  const create = useCreateClient();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [mode, setMode] = useState<"password" | "invite">("invite");
  const [password, setPassword] = useState("");

  return (
    <Modal title="Nouveau client" onClose={onClose}>
      {create.data ? (
        <div className="flex flex-col gap-3 text-sm">
          <p className="text-emerald-700">Compte créé.</p>
          {create.data.inviteUrl && (
            <code className="block break-all rounded bg-stone-100 p-2 text-xs">
              {create.data.inviteUrl}
            </code>
          )}
          <Button onClick={onClose}>Fermer</Button>
        </div>
      ) : (
        <form
          onSubmit={(e) => {
            e.preventDefault();
            create.mutate({
              name,
              email,
              mode,
              password: mode === "password" ? password : undefined,
            });
          }}
          className="flex flex-col gap-3"
        >
          <Field label="Nom">
            <Input required value={name} onChange={(e) => setName(e.target.value)} />
          </Field>
          <Field label="Email">
            <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
          </Field>
          <ModePicker mode={mode} onChange={setMode} />
          {mode === "password" && (
            <Field label="Mot de passe (8 car. min.)">
              <Input
                type="text"
                minLength={8}
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </Field>
          )}
          {create.isError && (
            <p className="text-sm text-rose-600">Échec (email déjà utilisé ?).</p>
          )}
          <Button type="submit" disabled={create.isPending}>
            Créer
          </Button>
        </form>
      )}
    </Modal>
  );
}
